import React, { SVGProps } from 'react';

export const AngleRightSmallIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M8.33357 14.1667C8.12023 14.1667 7.90687 14.0851 7.74437 13.9226C7.41854 13.5967 7.41854 13.07 7.74437 12.7442L10.4885 10L7.74437 7.25589C7.41854 6.93006 7.41854 6.40334 7.74437 6.0775C8.07021 5.75167 8.59693 5.75167 8.92276 6.0775L12.2561 9.41084C12.5819 9.73667 12.5819 10.2634 12.2561 10.5892L8.92276 13.9226C8.76026 14.0851 8.5469 14.1667 8.33357 14.1667Z"
      fill="#72757A"
    />
  </svg>
);
